import { CustomTriggerAccordionGroup } from "src/components/core-components/organisms/CustomTriggerAccordionGroup/custom-trigger-accordion-group";
import styled from "styled-components";

export const AccordionGroupWrapper = styled(CustomTriggerAccordionGroup.Root)`
  width: 100%;
`;
